<template>
    <scroll-bar>
        <div v-if="isCollapse" class="scrm-brand">CRM</div>
        <div v-else class="scrm-brand">业务系统</div>
        <el-menu mode="vertical" :router="true" unique-opened
                :default-active="$route.path"
                :collapse="isCollapse"
                background-color="#304156"
                text-color="#fff"
                active-text-color="#409EFF">
            <template v-for="item in routes" v-if="!item.hidden && item.children && moduleId == item.meta.module">
                <!-- 一级导航 00-->
                <el-menu-item
                        v-if="item.children.length===1 && !item.children[0].children"
                        :key="item.children[0].name"
                        :class="item.children[0].meta && item.children[0].meta.menuClass"
                        :index="item.path+'/'+item.children[0].path">
                    <i v-if="item.children[0].meta&&item.children[0].meta.icon" :class="item.children[0].meta.icon"></i>
                    <span slot="title" v-if="item.children[0].meta&&item.children[0].meta.title">{{item.children[0].meta.title}}</span>
                </el-menu-item>
                <el-submenu v-else :index="item.name||item.path" :key="item.name">
                    <template slot="title">
                        <i v-if="item.meta&&item.meta.icon" :class="item.meta.icon"></i>
                        <span v-if="item.meta&&item.meta.title">{{item.meta.title}}</span>
                    </template>
                    <template v-for="child in item.children" v-if="!child.hidden">
                        <el-menu-item :key="child.name" :class="child.meta && child.meta.menuClass" :index="item.path+'/'+child.path">
                            <i v-if="child.meta&&child.meta.icon" :class="child.meta.icon"></i>
                            <span slot="title" v-if="child.meta&&child.meta.title">{{child.meta.title}}</span>
                        </el-menu-item>
                    </template>
                </el-submenu>
            </template>
        </el-menu>
    </scroll-bar>
</template>

<script>

    import {mapGetters} from 'vuex'
    import ScrollBar from '~/widgets/ScrollBar.vue'
    import AccountService from '~/services/account'
    import {APP} from "~/config/app"

    export default {
        components: {ScrollBar},
        computed: {
            ...mapGetters([
                'sidebar'
            ]),
            moduleId() {
                return this.$store.state.app.moduleId

            },
            routes() {
                return this.getRoutes();
                //return this.$router.options.routes;
            },
            isCollapse() {
                return !this.sidebar.opened
            }
        },
        methods: {
            /**
             * 获取系统路由，同时对于当前登录用户无权访问的路由节点进行屏蔽
             * @returns {Array}
             */
            getRoutes() {

                if (!APP.enableAuthPermission) {
                    return this.$router.options.routes;
                }

                let data = this.$router.options.routes;
                let routes = [];
                if (data.length > 0) {
                    data.forEach(function (item) {
                        if (!item.hidden && item.children && item.children.length > 0) {
                            let childs = [];
                            item.children.forEach(function (child) {
                                let path = item.path + '/' + child.path;
                                if (!child.hidden && AccountService.canAccess(path, child.meta)) {
                                    childs.push(child)
                                }
                            });
                            if (childs.length > 0) {
                                item.children = childs;
                                routes.push(item);
                            }
                        }
                    });
                }
                return routes;
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

    .scrm-brand {
        color: #FFFFFF;
        font-size: 20px;
        width: 100%;
        height: 64px;
        text-align: center;
        font-weight: 600;
        line-height: 64px;
    }
</style>



// WEBPACK FOOTER //
// src/widgets/Sidebar.vue